export const _translations = {
	legacy: false,
	locale: 'de',
	messages: {
		en: {
			hubs: {
				common: {
					dash: '—',
				},
				header: {
					title: 'Hubs',
					totalModules: '{count} modules',
					searchPlaceholder: 'Search hubs',
					searchAria: 'Search hubs',
					sortAria: 'Sort hubs',
				},
				sort: {
					lastLog_desc: 'Last Call (newest)',
					lastLog_asc: 'Last Call (oldest)',
					name_asc: 'Hub Name (A→Z)',
					name_desc: 'Hub Name (Z→A)',
					projectName_asc: 'Project (A→Z)',
					projectName_desc: 'Project (Z→A)',
					moduleCount_desc: 'Module Count (high→low)',
					moduleCount_asc: 'Module Count (low→high)',
					state_asc: 'State (A→Z)',
				},
				list: {
					noMatch: 'No hubs match “{search}”.',
					noData: 'No hubs available yet.',
					modulesLabel: '{count} modules',
					graphsLabel: '{count} graphs',
					settings: 'Settings',
					project: 'Project',
					location: 'Location',
					lastCall: 'Last Call',
					ipAddress: 'IP Address',
					state: 'State',
					timezone: 'Timezone',
					modulesTitle: 'Modules',
					graphsTitle: 'Graphs',
				},
				modulesTable: {
					headers: {
						module: 'Module',
						serial: 'Serial',
						state: 'State',
						lastLog: 'Last Log',
						alertInterval: 'Data timeout',
						visibility: 'Visibility',
						id: 'Id',
						actions: 'Actions',
					},
					alertIntervalValue: '{value} min',
					visibilityInfo: {
						title: 'Visibility',
						description:
							'Whether the module is listed in the navigation on the left (under the location, for admins). Switched off, it disappears from there; the module page, hub page and location stay reachable, the module keeps being recorded and evaluated. Handy for removed or test modules.',
						note: 'Its status light still counts: a silent module keeps colouring hub, location and project — to stop that, set it to deactivated.',
					},
					customName: 'Display name',
					customNameHint: 'Shown instead of the automatic name in the navigation and the chart; empty = automatic name',
					dataTimeoutInfo: {
						title: 'Data timeout',
						description:
							'How long a module may go without new data. Once exceeded, its status light turns orange; after twice that time, red. The colour carries over to the hub, location and project above it. Best set somewhat above the module\'s usual sending rhythm (sends hourly → e.g. 3 h). Unrelated to the limit alarms of the graphs: no emails or SMS are sent.',
						note: 'Display only: nothing is stored, calculated or evaluated differently because of it.',
					},
					hidden: 'Hidden',
					visible: 'Visible',
					recalc: 'Recalculate',
					recalcAllStates: { waiting: 'waiting', running: 'running', done: 'done', failed: 'error' },
					recalcAllLast: 'Last recalculated: {date}',
					noModules: 'No modules connected.',
					toast: {
						recalcFailed: 'Recalculation failed.',
						recalcRequested: 'Recalculation requested.',
						recalcError: 'Error recalculating module.',
						alertIntervalUpdated: 'Data timeout updated.',
						alertIntervalFailed: 'Failed to update data timeout.',
						visibilityUpdated: 'Visibility updated.',
						customNameUpdated: 'Display name saved.',
						customNameFailed: 'Display name could not be saved.',
						visibilityFailed: 'Could not update visibility.',
						stateUpdated: 'State updated.',
						stateFailed: 'Could not update state.',
					},
				},
				graphsTable: {
					headers: {
						graph: 'Graph',
						state: 'State',
						lastLog: 'Last Log',
						linkedModule: 'Linked Module',
						id: 'Id',
					},
					empty: 'No graphs for this hub.',
				},
				settingsModal: {
					title: 'Hub Settings',
					titleWithName: 'Hub Settings – {name}',
					fields: {
						hubName: 'Hub Name',
						serial: 'Serial',
						project: 'Project',
						location: 'Location',
						state: 'State',
						logOffset: 'Log Offset (hours)',
						alertInterval: 'Alert Interval (min)',
					},
					placeholders: {
						selectProject: 'Select project',
						selectLocation: 'Select location',
						selectState: 'Select state',
					},
					states: {
						active: 'active',
						deactivated: 'deactivated',
					},
					toast: {
						saved: 'Hub updated',
						saveFailed: 'Failed to update hub',
					},
				},
				detail: {
					title: 'Hub',
					activate: 'Activate',
					meta: {
						serial: 'Serial',
						state: 'State',
						alert: 'Alert',
						created: 'Created',
						modified: 'Modified',
						lastLog: 'Last Log',
					},
					modulesTable: {
						headers: {
							state: 'State',
							name: 'Module Name',
							serial: 'Serial',
							created: 'Created',
							modified: 'Modified',
							lastLog: 'Last Log',
							alertInterval: 'Data timeout',
							visible: 'Visible In Sidebar',
						},
					},
				},
			},
		},
		de: {
			hubs: {
				common: {
					dash: '—',
				},
				header: {
					title: 'Hubs',
					totalModules: '{count} Module',
					searchPlaceholder: 'Hubs suchen',
					searchAria: 'Hubs suchen',
					sortAria: 'Hubs sortieren',
				},
				sort: {
					lastLog_desc: 'Letzter Call (neueste)',
					lastLog_asc: 'Letzter Call (älteste)',
					name_asc: 'Hub-Name (A→Z)',
					name_desc: 'Hub-Name (Z→A)',
					projectName_asc: 'Projekt (A→Z)',
					projectName_desc: 'Projekt (Z→A)',
					moduleCount_desc: 'Anzahl Module (hoch→niedrig)',
					moduleCount_asc: 'Anzahl Module (niedrig→hoch)',
					state_asc: 'Status (A→Z)',
				},
				list: {
					noMatch: 'Keine Hubs entsprechen „{search}“.',
					noData: 'Noch keine Hubs verfügbar.',
					modulesLabel: '{count} Module',
					graphsLabel: '{count} Graphen',
					settings: 'Einstellungen',
					project: 'Projekt',
					location: 'Standort',
					lastCall: 'Letzter Call',
					ipAddress: 'IP-Adresse',
					state: 'Status',
					timezone: 'Zeitzone',
					modulesTitle: 'Module',
					graphsTitle: 'Graphen',
				},
				modulesTable: {
					headers: {
						module: 'Modul',
						serial: 'Seriennummer',
						state: 'Status',
						lastLog: 'Letztes Log',
						alertInterval: 'Daten-Timeout',
						visibility: 'Sichtbarkeit',
						id: 'Id',
						actions: 'Aktionen',
					},
					alertIntervalValue: '{value} min',
					visibilityInfo: {
						title: 'Sichtbarkeit',
						description:
							'Ob das Modul in der Navigation links aufgeführt wird (unter dem Standort, für Admins). Ausgeschaltet verschwindet es dort; Modulseite, Hub-Seite und Standort bleiben erreichbar, das Modul wird weiter aufgezeichnet und ausgewertet. Praktisch für ausgebaute oder Test-Module.',
						note: 'Das Statuslicht zählt trotzdem: Ein stilles Modul färbt Hub, Standort und Projekt weiter ein – dafür das Modul auf deaktiviert setzen.',
					},
					customName: 'Anzeigename',
					customNameHint: 'Wird in der Navigation und im Chart statt des automatischen Namens gezeigt; leer = automatischer Name',
					dataTimeoutInfo: {
						title: 'Daten-Timeout',
						description:
							'Wie lange ein Modul ohne neue Daten bleiben darf. Wird diese Zeit überschritten, wird sein Statuslicht orange, nach der doppelten Zeit rot. Die Farbe gilt auch für Hub, Standort und Projekt darüber. Am besten etwas über dem üblichen Sendetakt des Moduls wählen (sendet es stündlich, z. B. 3 h). Hat nichts mit den Grenzwert-Alarmen der Graphen zu tun: Es werden keine E-Mails oder SMS verschickt.',
						note: 'Rein optisch: Gespeichert, berechnet oder ausgewertet wird dadurch nichts anders.',
					},
					hidden: 'Versteckt',
					visible: 'Sichtbar',
					recalc: 'Neu berechnen',
					recalcAllStates: { waiting: 'wartet', running: 'läuft', done: 'fertig', failed: 'Fehler' },
					recalcAllLast: 'Zuletzt berechnet: {date}',
					noModules: 'Keine Module verbunden.',
					toast: {
						recalcFailed: 'Neuberechnung fehlgeschlagen.',
						recalcRequested: 'Neuberechnung angefordert.',
						recalcError: 'Fehler bei der Neuberechnung.',
						alertIntervalUpdated: 'Daten-Timeout aktualisiert.',
						alertIntervalFailed: 'Daten-Timeout konnte nicht aktualisiert werden.',
						visibilityUpdated: 'Sichtbarkeit aktualisiert.',
						customNameUpdated: 'Anzeigename gespeichert.',
						customNameFailed: 'Anzeigename konnte nicht gespeichert werden.',
						visibilityFailed: 'Sichtbarkeit konnte nicht aktualisiert werden.',
						stateUpdated: 'Status aktualisiert.',
						stateFailed: 'Status konnte nicht aktualisiert werden.',
					},
				},
				graphsTable: {
					headers: {
						graph: 'Graph',
						state: 'Status',
						lastLog: 'Letztes Log',
						linkedModule: 'Verknüpftes Modul',
						id: 'Id',
					},
					empty: 'Keine Graphen für diesen Hub.',
				},
				settingsModal: {
					title: 'Hub-Einstellungen',
					titleWithName: 'Hub-Einstellungen – {name}',
					fields: {
						hubName: 'Hub-Name',
						serial: 'Seriennummer',
						project: 'Projekt',
						location: 'Standort',
						state: 'Status',
						logOffset: 'Log-Offset (Stunden)',
						alertInterval: 'Alarm-Intervall (Min.)',
					},
					placeholders: {
						selectProject: 'Projekt auswählen',
						selectLocation: 'Standort auswählen',
						selectState: 'Status auswählen',
					},
					states: {
						active: 'aktiv',
						deactivated: 'deaktiviert',
					},
					toast: {
						saved: 'Hub aktualisiert',
						saveFailed: 'Hub konnte nicht aktualisiert werden',
					},
				},
				detail: {
					title: 'Hub',
					activate: 'Aktivieren',
					meta: {
						serial: 'Seriennummer',
						state: 'Status',
						alert: 'Alarm',
						created: 'Erstellt',
						modified: 'Geändert',
						lastLog: 'Letztes Log',
					},
					modulesTable: {
						headers: {
							state: 'Status',
							name: 'Modulname',
							serial: 'Seriennummer',
							created: 'Erstellt',
							modified: 'Geändert',
							lastLog: 'Letztes Log',
							alertInterval: 'Daten-Timeout',
							visible: 'Sichtbar in Sidebar',
						},
					},
				},
			},
		},
	},
}
